// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var $$String = require("rescript/lib/js/string.js");
var Tooltip = require("./Tooltip.bs.js");
var UTCDate = require("./types/UTCDate.bs.js");
var DateFns = require("date-fns");
var Text__Jsx3 = require("../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Colors = require("uikit/styles/colors");

function RelativeDateLabel(props) {
  var date = props.date;
  var fontSize = props.fontSize;
  var color = props.color;
  var color$1 = color !== undefined ? color : Colors.gray;
  var fontSize$1 = fontSize !== undefined ? fontSize : ({
        NAME: "px",
        VAL: 13
      });
  return React.createElement(Tooltip.make, {
              label: DateFns.format(UTCDate.toUnzonedDate(date), "MM/dd/yyyy h:mma"),
              children: React.createElement("span", undefined, React.createElement(Text__Jsx3.make, {
                        as_: props.as_,
                        fontSize: fontSize$1,
                        color: color$1,
                        lineClamp: props.lineClamp,
                        className: props.className,
                        children: $$String.capitalize_ascii(DateFns.formatDistance(UTCDate.toUnzonedDate(date), new Date()) + " ago")
                      }))
            });
}

var make = RelativeDateLabel;

exports.make = make;
/* react Not a pure module */
